import { stringify } from 'qs';
import request from '../../../../../services/request';
import { url } from '../service-utils';

/**
 * 获取需要处理的异常数据列表，每次10条
 * 页面： 异常数据处理页面
 * 前端： 刘杰
 * 后端: 夏劲峰
 * @param {Number} taskId: 任务id
 * @param {Number} startNum:0, num: 10  写死
 */
export async function getNoMatchList(searParams) {
  return request(`${url.url}/internal/v2/batchImport/getNoMatchList?${stringify(searParams)}`);
}

/**
 * 保存
 * 页面： 异常数据处理页面
 * 前端： 刘杰
 * 后端: 夏劲峰
 * @param {Number} taskId: 任务id
 * @param {Array<Object>} updateArr: 需要更新的行数据列表
 */
export async function update(params) {
  return request(`${url.url}/internal/v2/batchImport/update`, {
    method: 'post',
    data: params,
  });
}

/**
 * 忽略
 * 页面： 异常数据处理页面
 * 前端： 刘杰
 * 后端: 夏劲峰
 * @param {Number} taskId: 任务id
 * @param {Array<Object>} rowIdList: 需要删除的id列表
 */
export async function ignore(params) {
  return request(`${url.url}/internal/v2/batchImport/ignore`, {
    method: 'post',
    data: params,
  });
}
